import { render, staticRenderFns } from "./Antipass.vue?vue&type=template&id=21434bff"
import script from "./Antipass.vue?vue&type=script&lang=ts"
export * from "./Antipass.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports